const EmailPerformanceWidget = ({ crmEmailId }) => {
  if (!crmEmailId) return null;

  return (
    <div className='py-3 pl-3 pr-3 mb-3 box-rounded box-outstanding-reports bg-white'>
      <h3 className='font-weight-bold'>Email performance</h3>
      <a
        className='w-100 d-block text-left specific-y-padding-6 px-3 text-decoration-none general-button rounded-pill text-925 bg-main-blue text-white d-flex align-items-center hover-opacity-85'
        href={`/people/email-performance/${crmEmailId}`}
        target='_blank'
        rel='noreferrer'
      >
        <span
          className='icon-email paragraph-p3 d-inline-block specific-right-margin-11 text-white'
          style={{ marginLeft: '-2px', transform: 'translateY(1px)' }}
        />
        <span className='text-white'>See email performance</span>
      </a>
    </div>
  );
};

export default EmailPerformanceWidget;
